// extracted by mini-css-extract-plugin
module.exports = {"BlockchainEra":"BlockchainEra_BlockchainEra__O14ko","vl":"BlockchainEra_vl__FWgSk","hr":"BlockchainEra_hr__nUPgM","h1":"BlockchainEra_h1__KlWuD"};